// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accent":"#27d0ca","second":"#f68839","third":"#2d6ecf","error":"#f44e4e","warning":"#ffa726","success":"#73c640","gray":"#333","white":"#fff","blue":"#2d6ecf"};